import { Constants, HelpItemType, HelpView } from "../constants.js";
import { HelpContainerTiles } from "../help-shared/help-container.jsx";
import { HelpArticle } from "./help-article.jsx";
import { getSelectedArticleMarkdown, getTilePageMarkdown } from "../functions/markdown.jsx";
import { useEffect } from "react";

export function HelpArticleRenderer(props) {
    useEffect(() => {
        if (typeof props.SetGetMarkdown !== "function" || !props.Visible) return;
        let markdownFn = null;
        if (props.SelectedItem == null) {
            markdownFn = () => getTilePageMarkdown(getTitle(), Constants.DocPageDescription, props.Articles, null, props.View ?? HelpView.Documentation);
        } else {
            markdownFn = () => getSelectedArticleMarkdown(props.SelectedItem, props.View ?? HelpView.Documentation);
        }

        if (markdownFn)
            props.SetGetMarkdown(() => markdownFn);

    }, [props.SelectedItem, props.Visible]);

    const getTitle = () => {
        return props.Title ?? Constants.DocPageTitle;
    };

    if (props.Visible === false) return null;

    return (<>
        <HelpContainerTiles
            Visible={props.SelectedItem === null}
            Theme={props.Theme}
            Name={getTitle()}
            Description={Constants.DocPageDescription}
            HideTileDescriptions={props.Theme !== "web"}
            Tiles={props.Articles}
            OnClick={(tile) => props.ChangeSelectedItem(tile.Slug, HelpItemType.Article)} />
        <HelpArticle
            Visible={props.SelectedItem !== null}
            Theme={props.Theme}
            Name={props.SelectedItem?.Title}
            Description={props.SelectedItem?.Description}
            Articles={props.SelectedItem?.Articles}
            Items={props.SelectedItem?.Items}
            RelatedArticles={props.SelectedItem?.RelatedArticles}
            BaseUrl={props.BaseUrl}
            OnClick={props.ChangeSelectedItem}
            OnClickRelated={props.OnClickRelated} />
    </>);
}